module.exports = __webpack_public_path__ + "img/emoji_93.da8d4ea0.png";